import React, { useState, useEffect, useMemo } from 'react';
import { Segment } from 'tea-component';
import { concat, find, get } from 'lodash-es';
import SegmentMultiple from '@/pages/datalab/components/SegmentMultiple';
import { useMount } from 'ahooks';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import SvgIcon from '@/pages/home/components/SvgIcon';

/**
 * 总结 折线图, 柱状图, 饼图上方筛选器需求
 * 筛选器分为3类:
 *    平台筛选器, 数据源筛选器, 指标筛选器
 * 显示规则:
 * 1. 平台筛选器一直都展示, 不置灰
 * 2. 数据源筛选器:
 *    (数据源筛选器是否置灰只受平台筛选器的控制, 和指标筛选器无关)
 *    点击平台筛选器时, 筛选数据为空的, 将选项置灰;
 *    点击指标筛选器时, 筛选数据为空的选项不置灰;
 * 3. 指标筛选器, 点击其他筛选器时, 筛选数据为空的, 不显示选项
 *
 */

function ChartFilter(props: any) {
  const { metrics = [], entities, sources, entityInfos, sourceInfos, metricInfos, activeType, onChange, value: filters , tableInfo} = props;
  // 筛选器选项
  const [metricOptions, setMetricOptions] = useState(metrics || []);
  const [entityOptions, setEntityOptions] = useState(entities || []);
  const [sourceOptions, setSourceOptions] = useState(sources || []);
  // 初始化获取图片等
  useMount(() => {
    const otherEntityOptions = concat([], entityOptions);
    const otherSourceOptions = concat([], sourceOptions);
    const gameIconConfig = {
      'mobile': 'other-icon',
      'pc': 'monitor',
      'console': 'game',
      'company': 'folded-graph'
    } as const;
    setEntityOptions(
      otherEntityOptions.map((task) => (
        {
          ...task,
          text: (
            <>
              <SvgIcon type={gameIconConfig[task?.value]} />
              {task?.text}
            </>
          )
        }
      ))
    );
    setSourceOptions(
      otherSourceOptions.map((task) => (
        {
          ...task,
          text: (
            <>
              {getDataSourceIcon(task.value) ? <img src={getDataSourceIcon(task.value)} alt="" /> : ''}
              {task?.text || task?.value}
            </>
          )
        }
      ))
    );
  });
  // 初始化获取对应枚举的数据源
  useEffect(() => {
    const entityValue = entityOptions?.[0]?.value;
    let sourceValue = sourceOptions?.[0]?.value;
    // let metricValue = metricOptions?.[0]?.value;
    let newMetricOptions: any[] = [];
    //
    if (entityOptions?.length > 0) {
      sourceValue = sourceOptions?.reduceRight((acc, opt) => {
        // 从后向前遍历, 给每个选项的disabled进行赋值, 同时得到第一个非disabled的值.
        // eslint-disable-next-line no-param-reassign
        opt.disabled = !entityInfos?.[entityValue]?.display?.includes(opt.value);
        return opt.disabled ? acc : opt.value;
      }, sourceValue);
      sourceValue = getOneMobileAnnie(entityValue, sourceValue) || sourceValue;
      metrics?.forEach((opt) => {
        // eslint-disable-next-line no-param-reassign
        opt.disabled = !(entityInfos?.[entityValue]?.display?.includes(opt.value) && (sourceValue ? sourceInfos?.[sourceValue]?.display?.includes(opt.value) : true));
        (!opt.disabled) && newMetricOptions.push(opt);
      });
    } else if (sourceOptions?.length > 0) {
      metrics?.forEach((opt) => {
        // eslint-disable-next-line no-param-reassign
        opt.disabled = !sourceInfos?.[sourceValue]?.display?.includes(opt.value);
        (!opt.disabled) && newMetricOptions.push(opt);
      });
    } else {
      newMetricOptions = metricOptions;
    }
    setMetricOptions(newMetricOptions);
    onChange({ entity: entityValue, source: sourceValue, metric: newMetricOptions[0]?.value });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 定制化功能(针对Top10品类数据以及地区数据，是没有数据源的，只有固定的2个指标，需要固定展示)
  const top10CategoryDataOrRegionalData = useMemo(() => {
    const firstElementUrl = get(tableInfo?.data, '[0].url', '')?.toLowerCase();
    const includesGenreProfile = firstElementUrl.includes("genreprofile") || firstElementUrl.includes("marketprofile");
    return includesGenreProfile;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableInfo?.data,filters]);
  // 当指标为手游时，如果数据源不是安妮，直接reset
  const getOneMobileAnnie = <T extends 'mobile' | 'console' | 'pc' & S, S = string>(
    type: T,
    source: S,
  ) => {
    if (type === 'mobile' && source !== 'appannie') {
      return get(
        find(sourceOptions, {
          value: 'appannie',
        }),
        'value',
        source,
      );
    }
  };

  const gameCountTypeHidden = useMemo(() => {
    if (entityOptions.length === 1 && sourceOptions.length === 1 && metricOptions.length === 1) {
      return true;
    }
  }, [entityOptions.length, metricOptions.length, sourceOptions.length]);
  return activeType !== 'table' ? (<>
    {
      (entityOptions?.length > 0) ? (<Segment
        style={{ marginRight: '10px' }}
        options={entityOptions}
        value={gameCountTypeHidden ? '': filters.entity}
        className="segmentContainer"
        onChange={(value) => {
				  let { source, metric } = filters;
				  let tempOfSource = '';
				  let tempOfMetric = '';
				  source = getOneMobileAnnie(value, source) || source;
				  sourceOptions?.forEach(opt => {
				    // eslint-disable-next-line no-param-reassign
				    opt.disabled = !(entityInfos[value]?.display?.includes(opt.value));
				    opt.value === source && (tempOfSource = opt);
				  });
				  tempOfSource?.disabled && (source = sourceOptions?.find(opt => !opt.disabled)?.value || source);

				  const newMetricOptions: any[] = [];
				  metrics?.forEach(opt => {
				    // eslint-disable-next-line no-param-reassign
				    opt.disabled = top10CategoryDataOrRegionalData ? false : !(entityInfos[value]?.display?.includes(opt.value) && source && sourceInfos[source]?.display?.includes(opt.value));
				    opt.value === metric && (tempOfMetric = opt);
				    (!opt.disabled) && newMetricOptions.push(opt);
				  });
				  tempOfMetric?.disabled && (metric = newMetricOptions[0]?.value || metric);
				  setSourceOptions([...sourceOptions]);
				  setMetricOptions(newMetricOptions);
          onChange({ source, metric: metric || metrics?.[0]?.value, entity: value });

        }}
      />) : ''
    }
    {
      (sourceOptions?.length > 0) ? (<Segment
        className="segmentContainer"
        options={sourceOptions}
        value={gameCountTypeHidden?'': filters.source}
        onChange={(value) => {

				  let { metric, entity } = filters;
				  let tempOfMetric = '';
				  let tempOfEntity = '';
				  entityOptions?.forEach(opt => {
				    // eslint-disable-next-line no-param-reassign
				    opt.disabledValue = !(sourceInfos[value]?.display?.includes(opt.value));
				    opt.value === entity && (tempOfEntity = opt);
				  });
				  tempOfEntity?.disabledValue && (entity = entityOptions?.find(opt => !opt.disabledValue)?.value || entity);
				  const newMetricOptions: any[] = [];
				  metrics?.forEach(opt => {
				    // eslint-disable-next-line no-param-reassign
				    opt.disabled = !(sourceInfos[value]?.display?.includes(opt.value) && entity && entityInfos[entity]?.display?.includes(opt.value));
				    opt.value === metric && (tempOfMetric = opt);
				    (!opt.disabled) && newMetricOptions.push(opt);
				  });
				  tempOfMetric?.disabled && (metric = newMetricOptions[0]?.value || metric);

				  // setEntityOptions([...entityOptions])
				  setMetricOptions(newMetricOptions);
				  onChange({ entity, metric, source: value });

        }}
      />) : ''
    }
    {
      (metricOptions?.length > 0) ? (<SegmentMultiple
        options={metricOptions}
        value={gameCountTypeHidden ? '' :filters.metric}
        onChange={(value) => {
				  let { source, entity } = filters;
				  let tempOfSource = '';
				  let tempOfEntity = '';
				  entityOptions?.forEach(opt => {
				    // eslint-disable-next-line no-param-reassign
				    opt.disabledValue = !(metricInfos[value]?.display?.includes(opt.value));
				    opt.value === entity && (tempOfEntity = opt);
				  });
				  tempOfEntity?.disabledValue && (entity = entityOptions?.find(opt => !opt.disabledValue)?.value || entity);

				  sourceOptions?.forEach(opt => {
				    // eslint-disable-next-line no-param-reassign
				    opt.disabledValue = !(metricInfos[value]?.display?.includes(opt.value) && entity && entityInfos[entity]?.display?.includes(opt.value));
				    opt.value === source && (tempOfSource = opt);
				  });
				  tempOfSource?.disabledValue && (source = sourceOptions?.find(opt => !opt.disabledValue)?.value || source);

				  // setEntityOptions([...entityOptions])
				  // setSourceOptions( [...sourceOptions])
				  onChange({ source, entity, metric: value });
        }}
        style={{ margin: 0 }}
        isMultiple={false}
      />) : ''
    }
  </>) : '';
}

export default ChartFilter;